module.exports = __webpack_public_path__ + "img/discover.c9edf8e.png";